import { render } from "./PhotoModal.vue?vue&type=template&id=064ac746&scoped=true"
import script from "./PhotoModal.vue?vue&type=script&lang=js"
export * from "./PhotoModal.vue?vue&type=script&lang=js"

import "./PhotoModal.vue?vue&type=style&index=0&id=064ac746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064ac746"]])

export default __exports__